import React from "react";
import { TransactionTypeHeader } from "../type";
import { FlexBox } from "../../primitives";
import { PrimaryButton } from "../../common/common.style";

interface TableSwitchProps {
  selected: TransactionTypeHeader;
  setSelected: (arg1: TransactionTypeHeader) => void;
}

export const TableSwitch = ({ selected, setSelected }: TableSwitchProps) => {
  const menuItems = ["Uploaded", "Edited", "Synced"] as const;

  return (
    <FlexBox css={{ gap: 12, padding: 16 }}>
      {menuItems.map((item) => (
        <PrimaryButton
          key={item}
          onClick={() => setSelected(item)}
          style={{
            padding: "8px 16px",
            borderRadius: 8,
            border: "1px solid #ccc",
            backgroundColor: selected === item ? "#4f46e5" : "#fff",
            color: selected === item ? "#fff" : "#333",
            fontWeight: selected === item ? "bold" : "normal",
            cursor: "pointer",
          }}
        >
          {item}
        </PrimaryButton>
      ))}
    </FlexBox>
  );
};
